var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatBalcony = function SvgFeatBalcony(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    viewBox: "0 0 14.2 15.2",
    width: 14.2,
    height: 15.2,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4574"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style4572"
  }, ".cls-1{fill-rule:evenodd;}"))), /*#__PURE__*/React.createElement("path", {
    fill: "#7f7f7f",
    className: "cls-1",
    d: "m 3.33,0.1 c -0.28,0 -0.5,0.22 -0.5,0.5 V 7.64 H 0.1 v 1 h 1.12 v 5.96 c 0,0.28 0.22,0.5 0.5,0.5 h 10.77 c 0.28,0 0.5,-0.22 0.5,-0.5 V 8.64 h 1.11 v -1 H 11.37 V 0.6 c 0,-0.28 -0.22,-0.5 -0.5,-0.5 z m -1.12,14 V 8.64 H 3.9 v 5.46 z m 2.69,0 H 6.59 V 8.64 H 4.9 Z m 2.69,0 H 9.28 V 8.64 H 7.59 Z m 4.39,0 H 10.29 V 8.64 h 1.69 z M 3.83,7.64 V 4.87 H 6.6 v 2.77 z m 3.77,0 h 2.77 V 4.87 H 7.6 Z m 0,-3.77 h 2.77 V 1.1 H 7.6 Z m -1,0 H 3.83 V 1.1 H 6.6 Z",
    id: "path4576",
    style: {
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgFeatBalcony;